<template>
	<div class="crmfollowlist">
		<el-card class="box-card" shadow="hover">
			<table class="table">
				<tr>
					<td class="td1"><span>标 题</span></td>
					<td style="text-align:left;">
						<el-input size="mini" ref="q_title" v-model="followup.q_title" @keyup.native="val => enterinput(val, '', 'q_contact')"></el-input>
					</td>
					<td class="td1"><span>联系人</span></td>
					<td><el-input size="mini" ref="q_contact" v-model="followup.q_contact" @keyup.native="val => enterinput(val, 'q_title', 'q_phone')"></el-input></td>
					<td class="td1"><span>联系电话</span></td>
					<td><el-input size="mini" ref="q_phone"  v-model="followup.q_phone" @keyup.native="val => enterinput(val, 'q_contact', 'q_context')"></el-input></td>
				</tr>
				<tr style="height:10px;"></tr>
				<tr>
					<td class="td1"><span>内容描述</span></td>
					<td colspan="5">
						<el-input type="textarea"  size="mini" rows="9" v-model="followup.q_context" ref="q_context" @keyup.native="val => enterinput(val, 'q_phone', 'followuptime')"></el-input>
					</td>
				</tr>
				<tr style="height:10px;"></tr>
				<tr>
					<td class="td1"><span>下次联系</span></td>
					<td>
						<el-date-picker
							ref="followuptime"
							size="mini"
							v-model="followup.followuptime"
							type="datetime"
							placeholder="选择日期时间"
							@keyup.native="val => enterinput(val, 'q_context', '')"
						></el-date-picker>
					</td>
					<td colspan="4"></td>
				</tr>
				<tr v-if="!btndisabled">
					<td colspan="6" style="text-align: center;">
						<el-button size="small" @click="reset">重置</el-button>
						<el-button size="small" type="success" @click="savecrmfollow(true)">新增记录</el-button>
					</td>
				</tr>
			</table>
		</el-card>
		<el-divider content-position="left">记录列表</el-divider>
		<div class="followup" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
			<div v-if="customerfollowup.length == 0" class="collapsetitle">暂无记录</div>
			<el-collapse v-model="activeNames" v-for="(item, index) in customerfollowup" :key="index">
				<el-collapse-item :name="index">
					<template slot="title">
						<span class="collapsetitle">
							<i class="el-icon-caret-right"></i>
							{{ item.q_title }}
						</span>
						<span class="collapsetitle2">
							记录账号：
							<label>{{ item.u_account }}</label>
						</span>
						<span class="collapsetitle2">
							记录时间：
							<label>{{ item.createtime }}</label>
						</span>
					</template>
					<div v-if="item.children.length > 0">
						<div>
							联系人： {{ item.q_contact }} {{ item.q_phone }}
							<br />
							内容描述：{{ item.q_context }}
						</div>
						<table>
							<tr :key="idx" v-for="(children, idx) in item.children">
								<td style="width:45%">
									<div v-if="children.u_userid == item.u_userid">
										<div class="tips">
											{{ children.u_account }}
											<span>{{ children.createtime }}</span>
										</div>
										<div class="dialogue">{{ children.q_context }}</div>
									</div>
									<div v-else style="color:transparent">1</div>
								</td>
								<td style="width:10%;color:transparent">1</td>
								<td style="width:45%">
									<div v-if="children.u_userid != item.u_userid">
										<div class="tips_r">
											{{ children.u_account }}
											<span>{{ children.createtime }}</span>
										</div>
										<div class="dialogue_r">{{ children.q_context }}</div>
									</div>
									<div v-else style="color:transparent">1</div>
								</td>
							</tr>
						</table>
					</div>
					<div v-if="item.children.length == 0">
						联系人： {{ item.q_contact }} {{ item.q_phone }}
						<br />
						内容描述：{{ item.q_context }}
					</div>
					<div style="width:40%;clear:both;margin-top:5px" v-if="item.contextreply==true">
						<el-input type="textarea" placeholder="请输入回复内容" size="mini" rows="5" v-model="item.reply"></el-input><span></span>
						<div style="text-align:right; margin-top:5px">
							<el-button size="mini" @click="cancel(item)">取消</el-button>
							<el-button size="mini" type="primary" @click="submit(item,index)">提交</el-button>
						</div>
					</div>
					<div style="clear:both;margin-top:5px" v-if="item.contextreply==false">
						<el-button size="mini" plain type="primary"  @click="showreply(item)">回复</el-button></div>
				</el-collapse-item>
			</el-collapse>
		</div>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {
		id: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			windowHeight: window.innerHeight - 460,
			customerfollowup: [],
			activeNames: [0],
			followup: {
				q_title: '',
				q_contact: '',
				q_phone: '',
				q_context: '',
				followuptime: ''
			},
			divclass: 'crmfollowlist',
			btndisabled: false,
			contextreply:false,
			follow_id:'',
			u_userid:''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/crm/crmfollowlist.scss');
		});
	},
	methods: {
		init(index) {
			//获取跟进记录
			var that = this;
			this.$nextTick(function() {
				this.$apipost.get.GetCustomerFollow({ crm_c_id: this.id }).then(res => {
					if (res.list != undefined) {
						res.list.forEach(e => {
							e.contextreply = false;
							e.reply='';
						});
						that.customerfollowup = res.list;
						if(index!=undefined)
							that.activeNames=[index];
					}
				});
			});
		},
		enterinput(event, perv, next) {
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if(next=='followuptime'&&event.keyCode==13)
						return false;
					if (next != '') this.$refs[next].focus();
				} else if (event.keyCode == 37) {
					if (perv != '') this.$refs[perv].focus();
				}
			}
		},
		//重置
		reset() {
			this.followup = {
				q_title: '',
				q_contact: '',
				q_phone: '',
				q_context: '',
				followuptime: ''
			};
		},
		//保存跟进记录
		savecrmfollow(isverify,item,index) {
			var that = this;
			var followinfo=JSON.parse(JSON.stringify(this.followup))
			if(isverify){
				if (followinfo.q_title == '') {
					this.$tool.message('请填写标题', 0);
					return false;
				}
				if (followinfo.q_context == '') {
					this.$tool.message('请填写内容描述', 0);
					return false;
				}
			}
			else{
				followinfo.q_context=item.reply;
			}
			followinfo.u_userid = localStorage.getItem('userid');
			followinfo.u_account = localStorage.getItem('u_account');
			followinfo.u_name = localStorage.getItem('u_name');

			var followup = {
				crm_c_id: this.id,
				crm_u_userid: this.u_userid,
				follow:followinfo,
				follow_id:this.follow_id
			};
			this.btndisabled = true;
			this.$tool.loading('正在保存', this.divclass);
			
			this.$apipost.post.SaveCustomerFollow({ paraminfo: followup }).then(res => {
				that.btndisabled = false;
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message(res.message, 1);
					if(item!=undefined)
					{
						that.follow_id='';
						that.u_userid='';
						item.contextreply=false;
						that.init(index);
					}
					else{
						that.reset();
						that.init();
					}
				}
				else {
					this.$tool.message(res.message, 0);
				}
			});
		},
		showreply(item) {
			this.customerfollowup.forEach(e => {
				e.contextreply = false;
			});
			item.contextreply=true;
			this.follow_id=item.id;
			this.u_userid=item.u_userid;
		},
		cancel(item){
			item.contextreply=false;
			this.follow_id='';
			this.u_userid='';
		},
		submit(item,index){
			this.savecrmfollow(false,item,index);
		}
	}
};
</script>

<style></style>
